import React, { useState } from "react";
import { formatPhoneNumber } from "./CommunityUtils";
import { trackButtonClick } from "../user/UserUtils";

const PhoneReveal = ({ phone, onClick }) => {
    const [isRevealed, setIsRevealed] = useState(false);

    if (!phone) {
        return null;
    }

    // this will not happen on desktop, but can happen on mobile.
    const handleClick = () => {
        setIsRevealed(true);

        gtag("event", "call_community", {
            event_category: "engagement",
        });

        const engagementCount = trackButtonClick("engagement");
        gtag("event", "engagementCountUpdated", {
            engagement_count: engagementCount,
        });

        gtag("event", "conversion", {
            send_to: "AW-10778046073/cgSQCO7AwJMaEPncr5Mo",
        });

        oaiq("measure", "lead_created", {
            type: "customer_action",
        });

        if (onClick) {
            onClick("clicked_community_phone");
        }
    };

    const handleMouseEnter = () => {
        setIsRevealed(true);

        gtag("event", "call_community_hover", {
            event_category: "engagement",
        });

        const engagementCount = trackButtonClick("engagement");
        gtag("event", "engagementCountUpdated", {
            engagement_count: engagementCount,
        });

        gtag("event", "conversion", {
            send_to: "AW-10778046073/cgSQCO7AwJMaEPncr5Mo",
        });

        oaiq("measure", "lead_created", {
            type: "customer_action",
        });

        if (onClick) {
            onClick("hover_community_phone");
        }
    };

    const handleClickPhone = () => {
        gtag("event", "call_community", {
            event_category: "engagement",
        });

        const engagementCount = trackButtonClick("engagement");
        gtag("event", "engagementCountUpdated", {
            engagement_count: engagementCount,
        });

        gtag("event", "conversion", {
            send_to: "AW-10778046073/cgSQCO7AwJMaEPncr5Mo",
        });

        oaiq("measure", "lead_created", {
            type: "customer_action",
        });

        if (onClick) {
            onClick("clicked_community_phone");
        }
    };

    if (isRevealed) {
        return (
            <a
                href={`tel:${phone}`}
                className="font-black text-primary-500 hover:text-primary-600 underline"
                onClick={handleClickPhone}
            >
                {formatPhoneNumber(phone)}
            </a>
        );
    }

    return (
        <button
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            className="font-black text-gray-700 hover:text-primary-500 underline cursor-pointer"
        >
            Hover or Click to see Phone number
        </button>
    );
};

export const communityWebsiteClick = () => {
    gtag("event", "click_community_website", {
        event_category: "engagement",
    });

    const engagementCount = trackButtonClick("engagement");
    gtag("event", "engagementCountUpdated", {
        engagement_count: engagementCount,
    });

    gtag("event", "conversion", {
        send_to: "AW-10778046073/cgSQCO7AwJMaEPncr5Mo",
    });

    oaiq("measure", "lead_created", {
        type: "customer_action",
    });
};

export const PdfPhoneClick = () => {
    gtag("event", "click_pdf_phone_number", {
        event_category: "engagement",
    });

    const engagementCount = trackButtonClick("engagement");
    gtag("event", "engagementCountUpdated", {
        engagement_count: engagementCount,
    });

    gtag("event", "conversion", {
        send_to: "AW-10778046073/cgSQCO7AwJMaEPncr5Mo",
    });

    oaiq("measure", "lead_created", {
        type: "customer_action",
    });
};

export default PhoneReveal;
